import { render } from "./PopoverFilter.vue?vue&type=template&id=46cf2a14"
import script from "./PopoverFilter.vue?vue&type=script&lang=js"
export * from "./PopoverFilter.vue?vue&type=script&lang=js"
script.render = render

export default script